// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__hGLK4","modal":"Modal_modal__hivo4","slide-down":"Modal_slide-down__9fnm1"};